var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActivityHistory',{attrs:{"title":"Driver Activity History","subtitle":_vm.subtitleText,"records":_vm.records,"loading":_vm.loading},on:{"close":_vm.closeDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }